const { InspectorControls } = wp.blockEditor;
const { PanelBody, ToggleControl, SelectControl, TextControl } = wp.components;
import SelectMargin from '../../wp-controlers/select-margin';
import SelectColor from '../../wp-controlers/select-color';
import SelectAlign from '../../wp-controlers/select-align';
import SelectMaxWidth from '../../wp-controlers/select-max-width';

const Inspector = ({ attributes, setAttributes }) => {
  const { containerized, titleTag, variant, anchor } = attributes;

  return (
    <InspectorControls>
      <PanelBody>
        <ToggleControl
          label="Este titulo está fora de um container?"
          checked={containerized}
          onChange={() => setAttributes({ containerized: !containerized })}
        />

        <SelectControl
          label="Selecione qual tag quer usar"
          title="Selecione qual tag quer usar"
          value={titleTag}
          options={[
            { label: 'H1', value: 'h1' },
            { label: 'H2', value: 'h2' },
            { label: 'H3', value: 'h3' },
            { label: 'H4', value: 'h4' },
            { label: 'H5', value: 'h5' },
            { label: 'H6', value: 'h6' },
            { label: 'p', value: 'p' },
          ]}
          onChange={(position) => setAttributes({ titleTag: position })}
        />

        <SelectControl
          label="Selecione o tamanho para esta heading tag"
          title="Selecione o tamanho para esta heading tag"
          value={variant}
          options={[
            { label: 'Desk: 56px - Mobile: 40px', value: 'title-1' },
            { label: 'Desk: 48px - Mobile: 32px', value: 'title-2' },
            { label: 'Desk: 40px - Mobile: 28px', value: 'title-3' },
            { label: 'Desk: 32px - Mobile: 24px', value: 'title-4' },
            { label: 'Desk: 24px - Mobile: 22px', value: 'title-5' },
            { label: 'Desk: 20px - Mobile: 16px', value: 'title-6' },
            { label: 'Subtítulo', value: 'subtitle' },
            { label: 'Texto', value: 'text' },
            { label: 'Label', value: 'caption' },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />

        <SelectColor attributes={attributes} setAttributes={setAttributes} />
        <SelectAlign attributes={attributes} setAttributes={setAttributes} />
        <SelectMargin attributes={attributes} setAttributes={setAttributes} />

        <TextControl
          label="ID do Heading: "
          value={attributes.anchor}
          onChange={(value) => setAttributes({ anchor: value })}
        />
        
        <SelectMaxWidth attributes={attributes} setAttributes={setAttributes} />

      </PanelBody>
    </InspectorControls>
  );
};

export default Inspector;
